import { ChangeEvent, useCallback } from 'react';
import {
  getIn,
  setIn,
  useField as useFieldFormik,
  useFormikContext,
} from 'formik';
import {
  FieldHelperProps,
  FieldInputProps,
  FieldMetaProps,
} from 'formik/dist/types';

export function useField<T>(
  name: string
): [
  FieldInputProps<T>,
  FieldMetaProps<T> & { apiError: string | undefined },
  FieldHelperProps<T>
] {
  const { setStatus, status } = useFormikContext<T>();
  const apiError = getIn(status, ['apiErrors', name]);
  const [
    { onChange: onChangeFormik, ...field },
    meta,
    helper,
  ] = useFieldFormik<T>(name);

  const onChangeMemo = useCallback(
    (e: ChangeEvent) => {
      if (apiError) {
        setStatus(setIn(status, `apiErrors.${name}`, undefined));
      }

      onChangeFormik(e);
    },
    [setStatus, status, name, onChangeFormik, apiError]
  );

  return [{ onChange: onChangeMemo, ...field }, { ...meta, apiError }, helper];
}
